/**
  checks if logged user is role
*/

const iam = (state, role) => {
  return state.user?.data?.role === role
}

export default iam
